export default __webpack_public_path__ + "static/media/picture3.05a8e4ca.png";